import { CcdRubriqueMontantModel } from '@cnaf.usagers.appli/cnaf-commons-dral'
import { ConstantesRessourcesEnfant } from '../constants/constante-ressources-enfant';
import { Validators } from '@angular/forms';

/**
 * Objet de sortie utilisé par le composant RessourcesEnfant
 */
export class RessourcesEnfantModel {
    listeRessources = new Array<RessourceEnfantModel>();
}

/**
 * Objet associé à une ressource d'un enfant
 */
export class RessourceEnfantModel {
    code: string;
    rubriqueData : CcdRubriqueMontantModel
}

/**
 * Objet contenant les propriétés d'une ressource pour un enfant
 */
export class ProprietesRessourceEnfantModel {
    id: string;
    code: string
    libelle: string;
    validators: Array<Validators>;
    placeHolder: string;
}

/**
 * Objet utilisé pour faciliter la récupération des données en provenance du RessourcesEnfantModel
 */
export class RessourcesEnfantModelAdapter {
    isSalaireDefini : boolean;
    salaire : string;

    isAllocationChomageDefini : boolean;
    allocationChomage : string;

    isRevenuOuDefinitTravailleurDefini : boolean;
    revenuOuDeficitTravailleur: string;

    mapRessources = new Map<string, CcdRubriqueMontantModel>();

    constructor(ressModel : RessourcesEnfantModel) {

        ressModel.listeRessources.forEach( val => {
            this.mapRessources.set(val.code, val.rubriqueData);
        });

        if (ressModel !== undefined && ressModel.listeRessources !== undefined) {
            this.salaire = this.mapRessources.get(ConstantesRessourcesEnfant.CODE_SALAIRE).montant;
            this.isSalaireDefini = this.mapRessources.get(ConstantesRessourcesEnfant.CODE_SALAIRE).isActive;

            this.allocationChomage = this.mapRessources.get(ConstantesRessourcesEnfant.CODE_ALLOCATION_CHOMAGE).montant;
            this.isAllocationChomageDefini = this.mapRessources.get(ConstantesRessourcesEnfant.CODE_ALLOCATION_CHOMAGE).isActive;

            this.revenuOuDeficitTravailleur = this.mapRessources.get(ConstantesRessourcesEnfant.CODE_REVENU_TRAVAILLEUR_INDEPENDANT).montant;
            this.isRevenuOuDefinitTravailleurDefini = this.mapRessources.get(ConstantesRessourcesEnfant.CODE_REVENU_TRAVAILLEUR_INDEPENDANT).isActive;
        }
    }
}
